<template>
    <div class="h-list-wrapper">
        <component
            :is="item.wtType"
            v-for="item in data.items"
            :key="item.uId"
            :data="item"
            :parentUId="data.uId"
            :isHlist="true"
            @selectClick="selectClick"
            class="h-list-item"
            @deleteItem="deleteItem"
        ></component>
        <AddItem @itemClick="addItem" v-show="isShowAdd" />
        <SelectItem v-show="showSelectItem" :itemData="itemData" @itemSelect="selectItemType" />
    </div>
</template>

<script>
import AddItem from "./AddItem";
import SelectItem from "@/views/zhiji/components/coverPanel/SelectItem";
import VideoItem from "./hListItems/VideoItem";
import StrategyItem from "./hListItems/StrategyItem";
import ImageItem from "./hListItems/ImageItem";
import ContainerItem from "./containerItem/ContainerItem";

export default {
    name: "HList",
    props: ["data"],
    components: {
        AddItem,
        SelectItem,
        VideoItem,
        StrategyItem,
        ImageItem,
        ContainerItem
    },
    data() {
        return {
            showSelect: true,
            ShowAdd: true
        };
    },
    computed: {
        itemData() {
            return [
                {
                    type: "image",
                    position: "-145px -50px",
                    name: this.$t("zhiji.answer.picture")
                },
                {
                    type: "video",
                    position: "-198px -50px",
                    name: this.$t("zhiji.answer.video")
                },
                {
                    type: "tip",
                    position: "-172px -50px",
                    name: this.$t("zhiji.answer.guides")
                },
                {
                    type: "question",
                    position: "-386px 73px",
                    name: this.$t("zhiji.answer.container"),
                    iconClass: "container-icon"
                }
            ];
        },
        showSelectItem() {
            return this.showSelect && !this.hasConfirmType() && this.showingItemLength < 10;
        },
        showingItemLength() {
            let len = 0;
            this.data.items.forEach(function(item) {
                if (item.updateState != "delete") {
                    len += 1;
                }
            });

            if (len === 0) {
                this.clearContainType();
            }

            return len;
        },
        isShowAdd() {
            return this.ShowAdd && this.hasConfirmType() && this.showingItemLength < 10;
        }
    },
    methods: {
        addItem() {
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "addContentItem",
                widget: {
                    uId: this.data.uId,
                    item: {
                        type: this.data.containType
                    }
                }
            });
        },
        hasConfirmType() {
            //横向列表允许混排
            return false;
        },
        selectItemType(item) {
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "updateContent",
                widget: {
                    uId: this.data.uId,
                    containType: item.type
                }
            });
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "addContentItem",
                widget: {
                    uId: this.data.uId,
                    item: {
                        type: item.type
                    }
                }
            });
            item.type != "video" && item.type != "tip" && item.type != "image" ? (this.showSelect = true) : (this.showSelect = false);
        },
        clearContainType() {
            this.data.containType &&
                this.$store.commit("zhiji/editQsUpdateAnswer", {
                    type: "updateContent",
                    widget: {
                        uId: this.data.uId,
                        containType: ""
                    }
                });
        },
        selectClick() {
            this.showSelect = true;
        },
        deleteItem() {
            this.showSelect = true;
        }
    }
};
</script>

<style lang="less" scoped>
.h-list-wrapper {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    flex-wrap: nowrap;
    position: relative;
}
</style>
